import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import React, { useEffect, useState } from "react";
import { axiosOpen } from "../../api/axios";
import CheckoutForm from "./CheckoutForm";
const stripePromis = loadStripe("pk_test_NBWPA3NVboDj6my1Q2nVubqG");

const Payment = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const planId = urlParams.get('planId');

  const [pageLoader, setPageLoader] = useState(false);
  const [dataLoader, setDataLoader] = useState(false);
  const [planDetails, setPlanDetails] = useState(null);
  const fetchPlanDetails = async () => {
    const response = await axiosOpen.get(`/api/subscription/item/${planId}`);
    setPlanDetails(response?.data);
    setDataLoader(false);
  };
  
  useEffect(() => {
    fetchPlanDetails();
  }, []);
  
  return (
    <div className="checkout-page col-md-6 m-auto shadow p-3 mt-5 bg-white rounded">
      <div className="container">
        <div className="section-title text-center pb-4">
          <h2>Enter your payment details</h2>
          <p>Total: ${planDetails?.amount}</p>
        </div>
        <Elements stripe={stripePromis}>
          <CheckoutForm planDetails={planDetails} />
        </Elements>
      </div>
    </div>
  );
};

export default Payment;
